/*eslint-disable */
// import CustomFormFieldsModel from '../../Model/CustomFormFields'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let CustomFormFieldss = {
  /**
   * customFormFieldsList
   */
  async customFormFieldsList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "custom_form_fields_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at customFormFieldsList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * customFormFieldsView
   */
  async customFormFieldsView (context, customFormFieldsId) {
    try {      
      let post_data = new FormData();
      post_data.append('cff_id', customFormFieldsId);
      return await request.curl(context, "custom_form_fields_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at customFormFieldsView() and Exception:",err.message)
    }    
  },

  /**
   * customFormFieldsAdd
   */
  async customFormFieldsAdd (context, customFormFieldsObj) {
    try{
      let post_data = new FormData();
    
      for (let key in customFormFieldsObj) {
        post_data.append(key, customFormFieldsObj[key]);
      }

      return await request.curl(context, "custom_form_fields_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at customFormFieldsAdd() and Exception:',err.message)
    }
  },

  /**
   * customFormFieldsEdit
   */
  async customFormFieldsEdit (context, customFormFieldsObj) {
    try{
      let post_data = new FormData();
    
      for (let key in customFormFieldsObj) {
        post_data.append(key, customFormFieldsObj[key]);
      }

      return await request.curl(context, "custom_form_fields_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at customFormFieldsEdit() and Exception:',err.message)
    }
  },

  /**
   * customFormFieldsDelete
   */
  async customFormFieldsDelete (context, customFormFieldsId) {
    try{
      let post_data = new FormData();
      
      post_data.append('cff_id', customFormFieldsId);

      return await request.curl(context, "custom_form_fields_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at customFormFieldsDelete() and Exception:',err.message)
    }
  }
}

export {
  CustomFormFieldss
}
